import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from '../actions/snackbarAction';
import { logOut } from '../actions/loginActions';

export function onTextMsgResponse(response) {
  return {
    type: types.TEXTMSG_RESPONSE,
    response
  };
}

export const textMsgList = async (params, dispatch, filterDate) => {
  const jwtToken = params;
  const body = {};
  const url = 'api/dc/student/message';

  if (filterDate) {
    body.DataDate = filterDate;
  }

  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        return dispatch(logOut());
      }
      dispatch(onTextMsgResponse(data));
    });
};
